import { createStore, setProp, setProps, withProps } from '@ngneat/elf';

export interface OaFiltersProps {
  text: string;
  tokens: string[];
  caseSensitive: boolean;
  tokenized: boolean;
  priceMin: number | null;
  priceMax: number | null;
  emptyOnNoFilter: boolean;
}

export const defaultFilters: OaFiltersProps = {
  caseSensitive: false,
  emptyOnNoFilter: true,
  priceMax: null,
  priceMin: null,
  text: '',
  tokenized: false,
  tokens: []
};

export const store = createStore({ name: 'oaFilters' },
  withProps<OaFiltersProps>({ ...defaultFilters }));

export const updateText = (text: string) => store.update(setProp('text', text));
export const updateMaxPrice = (price: number | null) => store.update(setProp('priceMax', price));
export const updateMinPrice = (price: number | null) => store.update(setProp('priceMin', price));
export const updateFilters = (filters: OaFiltersProps) => store.update(setProps(filters));

export const resetFilters = () => store.update(setProps(defaultFilters));

export const oaFilters$ = store.pipe();
